<!-- ========== App Menu ========== -->
<div class="app-menu navbar-menu">
  <!-- LOGO -->
  <div class="navbar-brand-box">
    <!-- Dark Logo-->
    <a routerLink="/" class="logo logo-dark" id="two-column-page-light-logo-block">
      <span class="logo-sm">
        <img [src]="helper.imageUrl + 'logo/titleLogoLightMode_DISPACHER.png'" alt="" />
      </span>
      <span class="logo-lg">
        <img [src]="helper.imageUrl + 'logo/logoLightMode_DISPACHER.png'" alt="" />
      </span>
    </a>
    <!-- Light Logo-->
    <a routerLink="/" class="logo logo-light" id="two-column-page-dark-logo-block">
      <span class="logo-sm">
        <img [src]="helper.imageUrl + 'logo/titleLogoDarkMode_DISPACHER.png'" alt="" />
      </span>
      <span class="logo-lg">
        <img [src]="helper.imageUrl + 'logo/logoDarkMode_DISPACHER.png'" alt="" />
      </span>
    </a>
    <button type="button" class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover" id="vertical-hover">
      <em class="ri-record-circle-line"></em>
    </button>
  </div>

  <div id="scrollbar">
    <div class="container-fluid">
      <div id="two-column-menu">
        <ul class="twocolumn-iconview" data-simplebar="init">
          <div class="simplebar-wrapper" style="margin: 0px">
            <div class="simplebar-mask">
              <div class="simplebar-offset" style="right: 0px; bottom: 0px">
                <div class="simplebar-content-wrapper" aria-label="scrollable content" style="height: 100%; overflow: hidden scroll">
                  <div class="simplebar-content" style="padding: 0px">
                    <!-- Dark Logo-->
                    <a routerLink="/" class="logo logo-light">
                      <img [src]="helper.imageUrl + 'logo/titleLogoLightMode_DISPACHER.png'" alt="" />
                    </a>
                    <!-- Light Logo-->
                    <a routerLink="/" class="logo logo-dark">
                      <img [src]="helper.imageUrl + 'logo/titleLogoDarkMode_DISPACHER.png'" alt="" />
                    </a>
                    @for(item of twoColumnFilteredMenuItems(twoColumnMenuItems); track $index){ @if(!item.isTitle){
                    <li>
                      @if(hasTwoColumnItems(item)){
                      <a href="javascript:void(0);" [attr.subitems]="item.collapseid" class="nav-icon" (click)="toggleTwoColumnItem($event)">
                        <em class="{{ item.icon }}" class=""></em>
                        <span data-key="t-dashboards" class="d-none">{{ item.label | translate }}</span>
                      </a>
                      }@else {
                      <a [routerLink]="item.link" [attr.subitems]="item.collapseid" class="nav-icon" (click)="toggleTwoColumnParentItem($event)">
                        <em class="{{ item.icon }}" class=""></em>
                        <span data-key="t-widget" class="d-none">{{ item.label | translate }}</span>
                      </a>
                      }
                    </li>
                    } }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </div>

      <ul class="navbar-nav" id="navbar-nav" data-simplebar="init">
        <div class="simplebar-wrapper" style="margin: 0px">
          <div class="simplebar-height-auto-observer-wrapper">
            <div class="simplebar-height-auto-observer"></div>
          </div>
          <div class="simplebar-mask">
            <div class="simplebar-offset" style="right: 0px; bottom: 0px">
              <ngx-simplebar class="simplebar-content-wrapper" style="max-height: 100vh">
                <div class="simplebar-content" style="padding: 0px">
                  <li class="menu-title"><span data-key="t-menu">Menu</span></li>
                  @for(item of twoColumnFilteredMenuItems(twoColumnMenuItems); track $index){
                  <li class="nav-item">
                    <ng-container>
                      <div class="collapse menu-dropdown" id="{{ item.collapseid }}" [attr.data-name]="item.label | translate" aria-expanded="true">
                        @if(hasTwoColumnItems(item)){
                        <ul class="nav nav-sm flex-column">
                          @for(subitem of item.subItems; track $index){
                          <li class="nav-item">
                            @if(hasTwoColumnItems(subitem)){
                            <a
                              class="nav-link ecomm"
                              data-bs-toggle="collapse"
                              [attr.aria-expanded]="!subitem.isCollapsed"
                              href="javascript:void(0);"
                              [attr.data-parent]="subitem.parentId"
                              (click)="toggleSubItem(subitem)"
                            >
                              {{ subitem.label | translate }}
                              @if(subitem.badge){<span class="badge badge-pill {{ subitem.badge.variant }}">{{ subitem.badge.text | translate }}</span
                              >}
                            </a>
                            <div class="collapse menu-dropdown sub-menu" #collapse="ngbCollapse" [(ngbCollapse)]="subitem.isCollapsed" id="{{ item.collapseid }}">
                              <ul class="nav nav-sm flex-column">
                                @for(subSubitem of subitem.subItems; track $index){
                                <li class="nav-item">
                                  @if(hasTwoColumnItems(subSubitem)){
                                  <a
                                    class="nav-link"
                                    href="javascript:void(0);"
                                    [attr.data-parent]="subSubitem.parentId"
                                    data-bs-toggle="collapse"
                                    [attr.aria-expanded]="!subSubitem.isCollapsed"
                                    (click)="toggleSubItem(subSubitem)"
                                  >
                                    {{ subSubitem.label | translate }}
                                    @if(subSubitem.badge){<span class="badge badge-pill {{ subSubitem.badge.variant }}">{{ subSubitem.badge.text | translate }}</span
                                    >}
                                  </a>

                                  <div class="collapse menu-dropdown extra-sub-menu" #collapse="ngbCollapse" [(ngbCollapse)]="subSubitem.isCollapsed">
                                    <ul class="nav nav-sm flex-column">
                                      @for(subSubitem1 of subSubitem.subItems; track $index){
                                      <li class="nav-item">
                                        <a [attr.data-parent]="subSubitem1.parentId" [routerLink]="subSubitem1.link" class="nav-link" (click)="updateActive($event)">
                                          {{ subSubitem1.label | translate }}
                                        </a>
                                      </li>
                                      }
                                    </ul>
                                  </div>
                                  }@else {
                                  <a [attr.data-parent]="subSubitem.parentId" [routerLink]="subSubitem.link" class="nav-link" (click)="updateActive($event)">
                                    {{ subSubitem.label | translate }}
                                    @if(subSubitem.badge){<span class="badge badge-pill {{ subSubitem.badge.variant }}">{{ subSubitem.badge.text | translate }}</span
                                    >}
                                  </a>
                                  }
                                </li>
                                }
                              </ul>
                            </div>
                            }@else {
                            <a [routerLink]="subitem.link" class="nav-link" [attr.data-parent]="subitem.parentId" (click)="updateActive($event)">
                              {{ subitem.label | translate }}
                              @if(subitem.badge){<span class="badge badge-pill {{ subitem.badge.variant }}">{{ subitem.badge.text | translate }}</span
                              >}
                            </a>
                            }
                          </li>
                          }
                        </ul>
                        }
                      </div>
                    </ng-container>
                  </li>
                  <!-- end Dashboard Menu -->
                  }
                </div>
              </ngx-simplebar>
            </div>
          </div>
          <div class="simplebar-placeholder" style="width: auto; height: 183px"></div>
        </div>
      </ul>
    </div>
    <!-- Sidebar -->
  </div>
  <div class="sidebar-background"></div>
</div>
<!-- Left Sidebar End -->
<!-- Vertical Overlay-->
<div class="vertical-overlay" (click)="twoColumnSidebarHide()"></div>
